<template>
  <v-container fill-height>
    <v-row justify="center">
      <v-col cols="12">
        <v-img
          src="https://i2.wp.com/ylh.org.hk/wp-content/uploads/2017/05/ylh_logo_2013b-png-1-e1495170476709.png?w=200&ssl=1"
          height="55"
          width="200"
          contain
        ></v-img>
        <div v-show="false">
          {{ selectedContactIndex }}
          CD: {{ selectedContact.userId }} msg:
          {{ selectedContact.messageInput }}
        </div>
      </v-col>
      <v-col cols="12">
        <div
          class="chatbox"
          id="app"
          @click="
            showOptions = false;
            showUserMenu = false;
            showColorPalette = false;
          "
          :class="darkMode ? 'darkMode' : ''"
        >
          <div class="chatbox__popupMenu" v-show="showOptions">
            <button @click="logout">
              LOGOUT
            </button>
          </div>
          <div class="chatbox__colorPalette" v-show="showColorPalette">
            <div
              class="chatbox__color"
              v-for="i in 12"
              @click="changeChannelColor"
            ></div>
          </div>

          <div class="chatbox__contacts">
            <v-list
              two-line
              dense
              height="100%"
              max-height="80vh"
              class="overflow-y-auto"
            >
              <v-list-item-group v-model="selectedContactIndex">
                <template
                  v-for="(contact, contactIndex) in contacts"
                  :class="
                    contactIndex === selectedContactIndex
                      ? 'chatbox__contact--selected'
                      : ''
                  "
                >
                  <v-list-item
                    :key="contactIndex"
                    @click="
                      selectedContactIndex = contactIndex;
                      focusInput();
                    "
                  >
                    <v-list-item-avatar v-if="contact.profileImage">
                      <v-img :src="contact.profileImage"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title
                        v-html="contact.name"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon>
                        <v-icon :color="contact.unread?`red`:`grey`">mdi-email-box</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </div>

          <div class="chatbox__container">
            <div class="chatbox__userMenu" v-if="showUserMenu"></div>
            <div class="chatbox__info">
              <span v-if="!is_admin"></span>
              <v-dialog
                v-model="dialog"
                scrollable
                max-width="300px"
                v-if="is_admin"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">Counsellor</v-btn>
                </template>
                <v-card>
                  <v-card-title>Select Counsellor(s)</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div v-for="user in sysusers">
                      <v-checkbox
                        dense
                        v-model="counsellor_match"
                        :label="user.username"
                        :value="user.user_id"
                      ></v-checkbox>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false"
                      >Close</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="saveassigneduser"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <p>
                {{ contacts[selectedContactIndex].name }}
              </p>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACJSURBVEhL7ZC9CYBADEbP2iEEp7JxAPdwBZex02EcQ/0iBCzC/ZlTkDx4RYrLC+cMwzB+QQ1bRRtYwSAbPJQdoRe6bIbS41x32MEg9NULlJakStEBRqMRT44yFF+htDRkdpTJiT+OMilxtSgTE1ePMr54sSgjxYtHmXv8tShD8Qn212QYxnc4dwKskJKEHrOFUQAAAABJRU5ErkJggg=="
                height="24"
                width="22"
                @click.stop.prevent="
                  showOptions = !showOptions;
                  showColorPalette = false;
                "
              />

            </div>
            <nav class="chatbox__navigation"></nav>

            <div class="chatbox__chat">

                <v-file-input
                v-model="fileinput"
    accept="image/*"
    label="File input"
  ></v-file-input>
      <v-btn
      color="blue-grey"
      class="ma-2 white--text"
      @click="previewFiles"
      :loading="fileuploading"
    >
      Send file
      <v-icon
        right
        dark
      >
        mdi-cloud-upload
      </v-icon>
    </v-btn>


              <v-text-field
                solo
                clearable
                counter
                class="chatbox__messageInput"
                v-model="selectedContact.messageInput"
                ref="newMessageInput"
                :placeholder="
                  firstMessageSent
                    ? 'New message...'
                    : 'New message... (press enter to send)'
                "
                @keyup.enter="newMessage()"

              ></v-text-field>

              <div class="chatbox__messages" ref="cmsgbox">
                <div
                  v-for="(message, messageIndex) in selectedChannel.messages"
                >
                  <div
                    class="chatbox__date"
                    v-if="messageIndex === 0 || messageIndex &gt; 0 &amp;&amp; selectedChannel.messages[messageIndex - 1].date !== message.date"
                  >
                    {{ message.date }}
                  </div>
                  <div
                    class="chatbox__messageContainer"
                    :class="
                      message.authorId == userId
                        ? 'chatbox__messageContainer--right'
                        : ''
                    "
                    :style="{
              'margin-top': messageIndex &gt; 0 &amp;&amp; selectedChannel.messages[messageIndex - 1].authorId !== message.authorId ? '12px':'4px',
              'margin-bottom': messageIndex &lt; (selectedChannel.messages.length - 1) &amp;&amp; selectedChannel.messages[messageIndex + 1].authorId !== message.authorId ? '12px':'4px'
            }"
                  >
                    <div
                      class="chatbox__message"
                      aria-label="message.content"
                      :style="{
                'background-color': message.authorId === userId ? selectedChannel.color:'',
                'border-top-right-radius': (messageIndex &gt; 0 &amp;&amp; selectedChannel.messages[messageIndex - 1].authorId === userId &amp;&amp; message.authorId === userId) ? '5px':'20px',
                'border-bottom-right-radius': (messageIndex &lt; (selectedChannel.messages.length - 1) &amp;&amp; selectedChannel.messages[messageIndex + 1].authorId === userId &amp;&amp; message.authorId === userId) ? '5px':'20px',
                'border-top-left-radius': (messageIndex &gt; 0 &amp;&amp; selectedChannel.messages[messageIndex - 1].authorId === message.authorId &amp;&amp; message.authorId !== userId) ? '5px':'20px',
                'border-bottom-left-radius': (messageIndex &lt; (selectedChannel.messages.length - 1) &amp;&amp; selectedChannel.messages[messageIndex + 1].authorId === message.authorId &amp;&amp; message.authorId !== userId) ? '5px':'20px'
              }"
                    >
                      <div
                        v-if="message.msgType == `chat`"
                        v-html="
                          message.content == ``
                            ? '[Whatsapp Sticker]'
                            : '<pre>' + message.content + '</pre>'
                        "
                      ></div>
                      <div v-else-if="message.msgType == `image`">
                        <v-img
                          :src="message.content"
                          lazy-src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
                          aspect-ratio="1"
                          min-width="150"
                          min-height="150"
                          @click="showImage(message.content)"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
                      <div
                        v-else-if="
                          message.msgType == `audio` || message.msgType == `ptt`
                        "
                      >
                        <audio controls>
                          <source :src="message.content" type="audio/ogg" />
                        </audio>
                      </div>
                      <div v-else>
                        {{ message.content }}
                      </div>
                      <div
                        class="chatbox__time"
                        :class="
                          message.authorId === userId
                            ? 'chatbox__time--left'
                            : ''
                        "
                      >
                        {{ message.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Message loading...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
      <v-dialog
      v-model="imageOpen"
      width="640"
    >
      <v-card>
        <v-card-text v-if="dialogimage">
        <v-img :src="dialogimage"   max-height="640"
  max-width="640"></v-img>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>


          <v-btn
            color="green darken-1"
            text
            @click="imageOpen = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";
import router from "@/router";
export default {
  computed: {
    selectedContact() {
      return this.contacts[this.selectedContactIndex];
    },
    selectedChannel() {
      return this.contacts[this.selectedContactIndex].channels[
        this.contacts[this.selectedContactIndex].selectedChannelIndex
      ];
    },
  },
  methods: {
    previewFiles: function(){
      let _self = this;
      if (this.fileinput == null) return;
     var formData = new FormData();
     _self.fileuploading= true;
      formData.append("chatId", this.selectedContact.userId);
      formData.append('file', this.fileinput); 

      axios
        .post("https://secureim.ylh.org.hk/srv2/sendfile.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          //console.log(response);
          _self.fileinput = null;
          _self.fileuploading=false;
        })
        .catch(function(error) {
          //console.log(error);
          _self.fileinput = null;
          _self.fileuploading=false;
        });
    },
    
    showImage(src){
      this.imageOpen = true;
      this.dialogimage = src;
    },
    logout() {
      localStorage.removeItem("token");
      router.push({ path: "/private/gate" });
    },
    loca() {
      this.$nextTick(() => {
        this.$refs.cmsgbox.scrollTop = this.$refs.cmsgbox.scrollHeight;
      });
    },
    focusInput() {
      this.$refs.newMessageInput.focus();
    },
    addUser(item) {
      //console.log(item);
      this.contacts.push({
        name: item.name,
        userId: item.id,
        newChannelInput: "",
        messageInput: "",
        makeNewChannel: false,
        selectedChannelIndex: 0,
        profileImage: item.image,
        last_time: item.last_time,
        unread: false,
        channels: [
          {
            name: "MAIN",
            color: "#09f",
            messages: [
              {
                content: "For privacy, please select contact on the left side.",
                date: "2019-02-06",
                time: "17:19",
                authorId: "jY0ty9S",
              },
            ],
          },
        ],
      });
      this.contacts.sort((a, b) => (a.last_time < b.last_time) ? 1 : -1)

    },
    fetchUserList() {
      let _self = this;
      let timenow = Date.now() / 1000 - 77760000;
      axios
        .get("https://secureim.ylh.org.hk/srv2/fetchcontacts.php", {
          params: {
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let ecc = response.data;
          //console.log(ecc);
          ecc.dialogs.forEach(function(item, idx) {
            if (item.isGroup || item.last_time < timenow) {
              //return;
            } else {
              _self.addUser(item);
            }
          });
        });
    },
    validelogin() {
      let _self = this;
      axios.get("https://secureim.ylh.org.hk/srv2/whstatus.php").then((response) => {
        let ecc = response.data;
        //console.log(ecc);
        if (ecc.accountStatus != "authenticated") {
          router.push({ path: "/private/error" });
        }
      });
    },
    getOptions() {
      let _self = this;
      _self.counsellor_match = [];
      this.sysusers.forEach(function(item, idx) {
        if (item.client_list.includes(_self.selectedContact.userId)) {
          _self.counsellor_match.push(item.user_id);
        }
      });
    },
    getUserMessage() {
      let _self = this;
      _self.fileinput=null;
      _self.fileuploading=false;
      this.validelogin();
      _self.contacts[_self.selectedContactIndex].channels[0].messages = [];
      this.dialog_loading = true;
      axios
        .get("https://secureim.ylh.org.hk/srv2/reader.php", {
          params: {
            token: localStorage.getItem("token"),
            chatId: this.selectedContact.userId,
            last: 20,
          },
        })
        .then((response) => {
          let ecc = response.data;
          //console.log(ecc);
          _self.getOptions();

          ecc.messages.forEach(function(item, idx) {
            if (_self.lastJimmy < item.time) _self.lastJimmy = item.time;
            _self.contacts[
              _self.selectedContactIndex
            ].channels[0].messages.push({
              content: item.body,
              date: new Date(item.time * 1000).toLocaleDateString(),
              time: new Date(item.time * 1000).toLocaleTimeString(),
              authorId: item.author,
              msgType: item.type,
            });
            _self.loca();
          });
          _self.contacts[
              _self.selectedContactIndex
            ].unread = false;
          this.dialog_loading = false;
        });
    },
    saveassigneduser() {
      let _self = this;
      var formData = new FormData();
      formData.append("client", this.selectedContact.userId);

      _self.counsellor_match.forEach((item) => {
        formData.append("user[]", item);
      });
      axios
        .post("https://secureim.ylh.org.hk/srv2/saveuser.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          //console.log(response);
          _self.dialog = false;
          _self.getuserlist();
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    getuserlist() {
      let _self = this;
      _self.sysusers = [];
      axios
        .get("https://secureim.ylh.org.hk/srv2/sysuser.php", {
          params: {},
        })
        .then((response) => {
          let ecc = response.data;

          ecc.users.forEach(function(item, idx) {
            _self.sysusers.push({
              user_id: item.user_id,
              username: item.username,
              client_list: JSON.parse(item.client_list),
            });
          });
        });
    },
    income() {
      let _self = this;
      if (_self.lastJimmy == 0) return;
      axios
        .get("https://secureim.ylh.org.hk/srv2/jimmy.php", {
          params: {
            time: _self.lastJimmy,
            chatId: _self.selectedContact.userId,
          },
        })
        .then((response) => {
          let ecc = response.data;

          ecc.messages.forEach(function(item, idx) {
            if (_self.lastJimmy < item.time) _self.lastJimmy = item.time;
            _self.contacts[
              _self.selectedContactIndex
            ].channels[0].messages.push({
              content: item.body,
              date: new Date(item.time * 1000).toLocaleDateString(),
              time: new Date(item.time * 1000).toLocaleTimeString(),
              authorId: item.author,
              msgType: item.type,
            });
            _self.loca();
          });

          ecc.incoming.forEach(function(item, idx) {
            var index = _self.contacts.findIndex(function (o) { return o.userId == item.author; })
            if (index != -1){
              //found
              _self.contacts[index].unread = true;
            }
          });
        });
    },
    addContact() {
      axios.get("https://randomuser.me/api/").then((response) => {
        let contact = response.data.results[0];
        this.contacts.push({
          name: contact.name.first + " " + contact.name.last,
          profileImage: contact.picture.medium,
          userId: contact.id.value,
          newChannelInput: "",
          messageInput: "",
          makeNewChannel: false,
          selectedChannelIndex: 0,
          unread: false,
          channels: [
            {
              name: "MAIN",
              color: "#09f",
              messages: [],
            },
          ],
        });
      });
    },
    sendws() {
      var formData = new FormData();
      formData.append("body", this.selectedContact.messageInput);
      formData.append("chatId", this.selectedContact.userId);
      axios
        .post("https://secureim.ylh.org.hk/srv2/testsend.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          //console.log(response);
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    addButtonClick() {
      this.selectedContact.makeNewChannel = true;
      this.$nextTick(() => {
        this.$refs.newChannelInput.focus();
      });
    },
    newChannel(name) {
      if (name.length > 0) {
        this.selectedContact.channels.push({
          name: this.selectedContact.newChannelInput,
          color: "#09f",
          messages: [],
        });
        this.selectedContact.newChannelInput = "";
        this.selectedContact.makeNewChannel = false;
        this.selectedContact.selectedChannelIndex =
          this.selectedContact.channels.length - 1;
        this.$refs.newMessageInput.focus();
      }
    },
    onChannelInputBlur() {
      if (this.selectedContact.newChannelInput === "") {
        this.selectedContact.makeNewChannel = false;
      } else {
        this.newChannel(this.selectedContact.newChannelInput);
      }
    },
    changeChannelColor(event) {
      let newColor = window.getComputedStyle(event.target).backgroundColor;
      this.selectedChannel.color = newColor;
    },
    deleteCurrentChannel() {
      let channelIndex = this.contacts[this.selectedContactIndex]
        .selectedChannelIndex;
      if (channelIndex > 0) {
        // Can't delete the main channel
        this.selectedContact.selectedChannelIndex = 0;
        this.selectedContact.channels.splice(channelIndex, 1);
        this.showOptions = false;
      }
    },
    deleteCurrentContact() {
      this.contacts.splice(this.selectedContactIndex, 1);
      if (this.selectedContactIndex > 0) {
        this.selectedContactIndex--;
      }
    },
    newMessage() {
      let _self = this;
      let url = "https://api.adviceslip.com/advice";
      if (this.selectedContact.messageInput.length > 0) {
        let today = new Date();
        this.selectedContact.channels[
          this.contacts[this.selectedContactIndex].selectedChannelIndex
        ].messages.push({
          content: this.selectedContact.messageInput,
          authorId: this.userId,
          time: this.getTime(),
          date: this.getDate(),
        });

        this.sendws();
        this.firstMessageSent = true;
        this.selectedContact.messageInput = "";
        _self.loca();
        // if (Math.floor(Math.random() * 3) === 1) {
        //   axios.get(url).then((response) => {
        //     this.selectedChannel.messages.push({
        //       content: response.data.slip.advice,
        //       authorId: this.selectedContact.userId,
        //       time: this.getTime(),
        //       date: this.getDate(),
        //     });
        //   });
        // }
      }
    },
    closePopup() {
      if (this.showOptions) {
        //console.log("loser");
        this.showOptions = false;
      }
    },
    getDate() {
      let date = new Date();
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10 ? "0" : "") +
        (date.getMonth() + 1) +
        "-" +
        (date.getDate() < 10 ? "0" : "") +
        date.getDate()
      );
    },
    getTime() {
      let date = new Date();
      return (
        (date.getHours() < 10 ? "0" : "") +
        date.getHours() +
        ":" +
        (date.getMinutes() < 10 ? "0" : "") +
        date.getMinutes()
      );
    },
  },
  mounted() {
    if (localStorage.getItem("is_admin") == "1") {
      this.is_admin = true;
    }
    this.getuserlist();
    this.fetchUserList();
    let _self = this;
    setTimeout(function() {
      _self.selectedContactIndex = 0;
    }, 1000);
  },
  watch: {
    selectedContactIndex(idx) {
      this.getUserMessage();
    },
  },
  created() {
    this.jimmyrun = setInterval(this.income, 5000);
  },
  destroy() {
    clearInterval(this.jimmyrun);
  },
  data() {
    return {
      imageOpen: false,
      dialogimage: null,
      dialog_loading: false,
      is_admin: false,
      sysusers: [],
      counsellor_match: [],
      dialog: false,
      jimmyrun: null,
      darkMode: false,
      showUserMenu: false,
      showOptions: false,
      userId: "85253133011@c.us",
      firstMessageSent: false,
      showColorPalette: false,
      selectedContactIndex: -1,
      selectedUser: null,
      contacts: [],
      lastJimmy: 0,
      fileinput: null,
      fileuploading: false
    };
  },
};
</script>
<style>
.chatbox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.chatbox__contacts {
  height: 100%;
  width: 275px;
  padding: 10px;
}
.chatbox__contact {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 5px;
  height: 55px;
  width: 55px;
  border-radius: 40px;
  cursor: pointer;
  border: 2px solid #fff;
  background-size: cover;
  background-position: center;
  background-color: #e6e6e6;
  transition-duration: 0.1s;
}
.chatbox__contact:hover {
  box-shadow: 0 0 0 2px #eee;
}
.chatbox__contact--selected {
  box-shadow: 0 0 0 2px #09f !important;
}
.chatbox__onlineIndicator {
  position: absolute;
  width: 16px;
  height: 16px;
  right: 0;
  bottom: 0;
  background-color: #2de58d;
  border-radius: 50px;
  border: 2px solid #fff;
}
.chatbox__container {
  position: relative;
  width: calc(100% - 275px);
  height: 100%;
}
.chatbox__info,
.chatbox__navigation {
  align-self: flex-start;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
}
.chatbox__info {
  padding: 10px 10px;
  display: flex;
  align-items: center;
  text-transform: capitalize;
  justify-content: space-between;
}
.chatbox__info img {
  cursor: pointer;
}
.chatbox__navigation {
  display: flex;
  height: auto;
  align-items: center;
  text-align: left;
  padding: 8px 10px;
}
.chatbox__channelSwitchButton,
.chatbox__channelNewButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  font-weight: 400;
  white-space: nowrap;
  border-radius: 40px;
  margin: 0 9px 0 0;
  font-size: 11px;
  height: 25px;
  padding: 4px 12px;

  border: 1px solid #09f;
  color: #09f;
  cursor: pointer;
}
.chatbox__channelSwitchButton input,
.chatbox__channelNewButton input {
  margin: 0;
  padding: 0 4px;
  border: none;
  height: 100%;
  width: 96px;
  text-align: left;
  font: inherit;
}
.chatbox__channelSwitchButton input::placeholder,
.chatbox__channelNewButton input::placeholder {
  color: #bbb;
}
.chatbox__channelSwitchButton--selected,
.chatbox__channelNewButton--selected {
  background: #09f;
  color: #fff !important;
}
.chatbox__channelSwitchButton--input,
.chatbox__channelNewButton--input {
  padding: 0 8px;
  cursor: default;
  display: flex;
}
.chatbox__channelNewButton {
  border-color: #e4e4e4;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 25px;
  width: 25px;
  color: #555;
  font-weight: 100;
  font-size: 22px;
  transition-duration: 0.1s;
}
.chatbox__channelNewButton:hover {
  border-color: #aaa;
}
.chatbox__chat {
  position: relative;
  height: calc(100% - 78px);
}
.chatbox__messages {
  margin: 0 auto;
  height: 70vh;
  padding: 20px;
  padding-bottom: 75px;
  overflow-y: auto;
}
.chatbox__messageInput {
  position: absolute;
  display: block;
  font: inherit;
  font-size: 13px;
  text-align: left;
  position: absolute;
  margin: 0 auto;
  right: 0;
  left: 0;
  height: 37px;
  padding: 2px 19px;

  bottom: 26px;
  z-index: 2;
}
.chatbox__messageInput::placeholder {
  color: #bbb;
}
.chatbox__messageContainer {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 6px 0;
  justify-content: flex-start;
}
.chatbox__messageContainer--right {
  justify-content: flex-end;
}
.chatbox__messageContainer--right .chatbox__message {
  color: #fff;
  border: none;
}
.chatbox__message {
  position: relative;
  max-width: 400px;
  padding: 6px 15px;
  text-align: left;
  border-radius: 20px;
  font-size: 12px;
  color: #000;
  word-break: break-word;
  background-color: #f4f4f4;
}
.chatbox__message:hover .chatbox__time {
  display: block;
}
.chatbox__message pre {
  font-size: 14px;
  word-break: keep-all;
  white-space: normal;
}
.chatbox__time {

  position: absolute;
  color: #888;
  right: -68px;
  top: calc(50% - 9px);
}
.chatbox__time--left {
  left: -68px;
  right: auto;
}
.chatbox__date {
  width: 100%;
  height: 20px;
  text-align: center;
  margin: 13px 0 10px;
  font-size: 12px;
  color: #ccc;
}
.chatbox__date:nth-child(1) {
  margin-top: 0;
}
.chatbox__popupMenu,
.chatbox__colorPalette,
.chatbox__userMenu {
  position: absolute;
  right: 10px;
  top: 40px;
  background: #fff;
  width: 200px;
  border-radius: 5px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  z-index: 2;
}
.chatbox__popupMenu button,
.chatbox__colorPalette button,
.chatbox__userMenu button {
  width: 100%;
  padding: 8px 10px;
  cursor: pointer;
  background-color: #fff;
  border: none;
}
.chatbox__popupMenu button:hover,
.chatbox__colorPalette button:hover,
.chatbox__userMenu button:hover {
  background: #f4f4f4;
}
.chatbox__popupMenu button:last-child,
.chatbox__colorPalette button:last-child,
.chatbox__userMenu button:last-child {
  color: #f00;
}
.chatbox__popupMenu button:disabled,
.chatbox__colorPalette button:disabled,
.chatbox__userMenu button:disabled,
.chatbox__popupMenu button button[disabled],
.chatbox__colorPalette button button[disabled],
.chatbox__userMenu button button[disabled] {
  cursor: default;
  color: #bbb;
}
.chatbox__popupMenu button:disabled:hover,
.chatbox__colorPalette button:disabled:hover,
.chatbox__userMenu button:disabled:hover,
.chatbox__popupMenu button button[disabled]:hover,
.chatbox__colorPalette button button[disabled]:hover,
.chatbox__userMenu button button[disabled]:hover {
  background: #fff;
}
.chatbox__colorPalette {
  width: auto;
  padding: 9px;
  display: grid;
  grid-template: 1fr 1fr 1fr/1fr 1fr 1fr 1fr;
  grid-gap: 5px;
}
.chatbox__userMenu {
  right: auto;
  left: 10px;
}
.chatbox__color {
  width: 25px;
  height: 25px;
  border-radius: 30px;
  cursor: pointer;
}
.chatbox__color:hover {
  opacity: 0.9;
}
.chatbox__color:nth-child(1) {
  background-color: #ff7ca8;
}
.chatbox__color:nth-child(2) {
  background-color: #247ba0;
}
.chatbox__color:nth-child(3) {
  background-color: #70c1b3;
}
.chatbox__color:nth-child(4) {
  background-color: #b2dbbf;
}
.chatbox__color:nth-child(5) {
  background-color: #ff1654;
}
.chatbox__color:nth-child(6) {
  background-color: #ffba08;
}
.chatbox__color:nth-child(7) {
  background-color: #3f88c5;
}
.chatbox__color:nth-child(8) {
  background-color: #23bf73;
}
.chatbox__color:nth-child(9) {
  background-color: #ff0f80;
}
.chatbox__color:nth-child(10) {
  background-color: #fe4e00;
}
.chatbox__color:nth-child(11) {
  background-color: #f19a3e;
}
.chatbox__color:nth-child(12) {
  background-color: #09f;
}
.darkMode {
  color: #fff;
  background: #222;
}
.darkMode footer,
.darkMode .chatbox__info,
.darkMode .chatbox__navigation,
.darkMode .chatbox__channelSwitchButton,
.darkMode .chatbox__channelNewButton,
.darkMode .chatbox__colorPalette,
.darkMode .chatbox__userMenu {
  color: #fff;
  background: #222;
}
.darkMode .chatbox__contacts,
.darkMode .chatbox__contact,
.darkMode .chatbox__info,
.darkMode .chatbox__navigation {
  border-color: #444;
}
.darkMode .chatbox__message {
  background: #444;
  color: #fff;
}
.darkMode .chatbox__messageInput {
  background: #444;
  color: #fff;
}
.darkMode .chatbox__channelNewButton img,
.darkMode .chatbox__info img,
.darkMode .chatbox__navigation img {
  filter: invert(100%);
}
@media screen and (max-width: 600px) {
  .chatbox__contacts {
    width: 85px;
  }
  .chatbox__container {
    width: calc(100% - 85px);
  }
}
@media screen and (max-width: 640px) {
  .chatbox__messageInput {
    width: 290px;
  }
}
</style>
